module.exports = __webpack_public_path__ + "assets/img/dzh-23.79bd1df9.png";